import { Component } from 'react'
import { connect } from 'react-redux'
import { PROPOSALS_UPDATE_FETCH_REQ } from '../actions'
import { ProposalsReviewTemplate } from 'components/Dashboard/ProposalsReviewTemplate'
import { fromProposals } from '../serializers'

@connect(({ dashboard }) => {
  return {
    dashboard
  }
})
class ProposalsUpdateContainer extends Component {
  componentDidMount() {
    this.props.dispatch({
      type: PROPOSALS_UPDATE_FETCH_REQ
    })
  }

  render() {
    return (
      <ProposalsReviewTemplate
        title="Proposals I Need to Update"
        subTitle="Below is a list of opportunities I have proposals to change/update"
        proposals={fromProposals(this.props.dashboard.proposalsINeedToUpdate)}
      />
    )
  }
}

export default ProposalsUpdateContainer
